

<app-loading-spinner></app-loading-spinner>
<router-outlet></router-outlet>
<p-confirmDialog />

<p-toast styleClass="custom-toast" key="globalToast" [life]="2500" ></p-toast>
<div class="flex justify-center">
    <p-blockUI [blocked]="(warningBlockedDocument$ | async) || false"></p-blockUI>
    <p-toast position="center" key="confirm" (onClose)="onReject()" [baseZIndex]="5000">
      <ng-template let-message pTemplate="message">
        <div class="flex flex-col" style="flex: 1">
          <div class="text-center">
            <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
            <h4>{{ warningSummary$ | async }}</h4>
            <p>{{ warningDetail$ | async}}</p>
          </div>
          <div class="grid grid-cols-12 gap-4 p-fluid">
            <div class="col-span-12">
              <button type="button" pButton (click)="onConfirm()" label="Ok" class="p-button-success"></button>
            </div>
          </div>
        </div>
      </ng-template>
    </p-toast>
  </div>